(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  function getItemFullTitle(el) {
    return (el.getAttribute('data-product-title') ||
            el.querySelector('.product-card__name')?.textContent ||
            el.querySelector('a[title]')?.getAttribute('title') ||
            '').trim();
  }

  function getItemSku(el) {
    return (el.getAttribute('data-display-sku') || '').trim();
  }

  function getItemBaseTitle(el) {
    let t = getItemFullTitle(el).toLowerCase();
    if (t.includes(' - ')) t = t.split(' - ')[0].trim();
    else if (t.includes(' / ')) t = t.split(' / ')[0].trim();
    return t;
  }

  // Knuth's multiplicative hashing algorithm
  function hashProductId(id) {
    const cleanId = String(id || '').replace(/\D/g, '');
    const num = parseInt(cleanId, 10);
    if (isNaN(num)) return 0;
    return ((num * 2654435761) % 4294967296) >>> 0;
  }

  function shouldDisperseGrid() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');

    // 1. If NO sort_by in URL -> this is the FIRST-TIME RENDER! ALWAYS RUN!
    if (!sortBy) return true;

    // 2. If user selected Most relevant, Featured, or Best selling -> RUN!
    if (sortBy === 'best-selling-sku' || sortBy === 'manual' || sortBy === 'best-selling' || sortBy === 'most-relevant') {
      return true;
    }

    // 3. Only bypass if user explicitly clicked strict price or strict A-Z sort
    const strictSorts = ['price-ascending', 'price-descending', 'title-ascending', 'title-descending'];
    if (strictSorts.includes(sortBy)) {
      return false;
    }

    return true;
  }

  function removeSlashlessItems() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const items = grid.querySelectorAll('.js-product-item');
    items.forEach(function(item) {
      const rawSku = item.getAttribute('data-product-sku');
      const hasCard = item.querySelector('.product-card') !== null;
      if (!hasCard || (rawSku !== null && !rawSku.includes('/'))) {
        item.remove();
      }
    });
  }

  let isBackfilling = false;

  async function fillGridToTarget() {
    if (isBackfilling) return;
    if (typeof brandState !== 'undefined' && brandState.selectedBrands && brandState.selectedBrands.size > 0) {
      return;
    }
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const currentPage = parseInt(grid.getAttribute('data-current-page') || '1', 10);
    const totalPages = parseInt(grid.getAttribute('data-total-pages') || '1', 10);

    // If on the last page (or only 1 page), never backfill!
    // The items remaining on this page (e.g. 2 out of 14) are legitimately fewer than targetCount.
    if (totalPages <= 1 || currentPage >= totalPages) {
      disperseGridProductsByTitle();
      return;
    }

    const targetCount = parseInt(grid.getAttribute('data-products-per-page') || '12', 10);
    if (!targetCount || targetCount <= 0) {
      disperseGridProductsByTitle();
      return;
    }

    removeSlashlessItems();

    let items = Array.from(grid.querySelectorAll('.js-product-item')).filter(function(el) {
      return el.querySelector('.product-card') !== null;
    });

    if (items.length >= targetCount) {
      disperseGridProductsByTitle();
      return;
    }

    let nextUrl = grid.getAttribute('data-next-url');
    if (!nextUrl && !grid.hasAttribute('data-next-url')) {
      const nextLink = document.querySelector('a.pagination__item[aria-label="Next page"]:not([aria-label="Previous page"]), a.pagination__item-arrow[aria-label="Next page"]:not([aria-label="Previous page"]), .AjaxinatePagination a[href]');
      nextUrl = nextLink ? nextLink.getAttribute('href') : null;
    }
    if (!nextUrl) {
      disperseGridProductsByTitle();
      return;
    }

    isBackfilling = true;
    const visitedUrls = new Set([window.location.href, nextUrl]);
    const existingIds = new Set(items.map(function(el) { return el.getAttribute('data-product-id'); }));

    try {
      while (items.length < targetCount && nextUrl) {
        const response = await fetch(nextUrl);
        if (!response.ok) break;
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const fetchedItems = Array.from(doc.querySelectorAll('#product-grid .js-product-item')).filter(function(el) {
          const prodId = el.getAttribute('data-product-id');
          if (prodId && existingIds.has(prodId)) return false;
          const rawSku = el.getAttribute('data-product-sku');
          const hasCard = el.querySelector('.product-card') !== null;
          return hasCard && (rawSku === null || rawSku.includes('/'));
        });

        const docGrid = doc.getElementById('product-grid');
        let newNextUrl = docGrid ? docGrid.getAttribute('data-next-url') : null;
        if (!newNextUrl && docGrid && !docGrid.hasAttribute('data-next-url')) {
          const docNextLink = doc.querySelector('a.pagination__item[aria-label="Next page"]:not([aria-label="Previous page"]), a.pagination__item-arrow[aria-label="Next page"]:not([aria-label="Previous page"]), .AjaxinatePagination a[href]');
          newNextUrl = docNextLink ? docNextLink.getAttribute('href') : null;
        }

        if (fetchedItems.length === 0) {
          if (!newNextUrl || visitedUrls.has(newNextUrl)) break;
          visitedUrls.add(newNextUrl);
          nextUrl = newNextUrl;
          continue;
        }

        const needed = targetCount - items.length;
        const toAppend = fetchedItems.slice(0, needed);

        toAppend.forEach(function(item) {
          existingIds.add(item.getAttribute('data-product-id'));
          grid.appendChild(item);
          if (typeof ingestProductItem === 'function') {
            ingestProductItem(item);
          }
        });

        items = Array.from(grid.querySelectorAll('.js-product-item')).filter(function(el) {
          return el.querySelector('.product-card') !== null;
        });

        if (items.length >= targetCount) {
          if (newNextUrl) {
            grid.setAttribute('data-next-url', newNextUrl);
          }
          break;
        }

        if (!newNextUrl || visitedUrls.has(newNextUrl)) break;
        visitedUrls.add(newNextUrl);
        nextUrl = newNextUrl;
      }
    } catch (err) {
      console.error('[Shopify Grid Backfill] Error:', err);
    } finally {
      isBackfilling = false;
      disperseGridProductsByTitle();
      if (typeof updateBrandSidebarUI === 'function') {
        updateBrandSidebarUI();
      }
      if (typeof renderFilteredGrid === 'function' && typeof brandState !== 'undefined' && brandState.selectedBrands && brandState.selectedBrands.size > 0) {
        renderFilteredGrid();
      }
    }
  }

  window.fillGridToTarget = fillGridToTarget;

  function disperseGridProductsByTitle() {
    removeSlashlessItems();

    if (!shouldDisperseGrid()) {
      const activeSort = new URLSearchParams(window.location.search).get('sort_by');
      console.log('[Shopify Title Randomizer] Strict sort active (' + activeSort + '), skipping title dispersal.');
      return;
    }

    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll('.js-product-item')).filter(function(item) {
      const rawSku = item.getAttribute('data-product-sku');
      const hasCard = item.querySelector('.product-card') !== null;
      if (!hasCard || (rawSku !== null && !rawSku.includes('/'))) {
        item.remove();
        return false;
      }
      return true;
    });
    if (items.length <= 1) return;

    // Check if the page has varied base titles or if all items share the same base title
    const baseTitles = new Set(items.map(el => getItemBaseTitle(el)).filter(Boolean));
    const hasMultipleBaseTitles = baseTitles.size > 1;

    function getGroupingKey(el) {
      if (hasMultipleBaseTitles) {
        return getItemBaseTitle(el);
      }
      // When all items share the same base title (e.g. all are Fluid Section Service kits),
      // differentiate them by Full Title and SKU / Part number:
      const full = getItemFullTitle(el).toLowerCase();
      const sku = getItemSku(el).toLowerCase();
      return full + (sku ? '::' + sku : '');
    }

    // 1. Group products by determined key
    const groups = new Map();
    for (const item of items) {
      const key = getGroupingKey(item);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    }

    // 2. Shuffle items within each group
    for (const list of groups.values()) {
      list.sort(function(a, b) {
        const idA = a.getAttribute('data-product-id') || '';
        const idB = b.getAttribute('data-product-id') || '';
        return (hashProductId(idA) - hashProductId(idB)) || (Math.random() - 0.5);
      });
    }

    // 3. Multi-bucket round-robin: Interleave buckets starting with the largest
    const buckets = Array.from(groups.values()).sort((a, b) => b.length - a.length);
    const reordered = [];
    let remaining = items.length;
    let lastKey = null;

    while (remaining > 0) {
      let chosenIdx = -1;
      for (let i = 0; i < buckets.length; i++) {
        if (buckets[i].length > 0 && getGroupingKey(buckets[i][0]) !== lastKey) {
          chosenIdx = i;
          break;
        }
      }

      if (chosenIdx === -1) {
        for (let i = 0; i < buckets.length; i++) {
          if (buckets[i].length > 0) {
            chosenIdx = i;
            break;
          }
        }
      }

      const item = buckets[chosenIdx].pop();
      reordered.push(item);
      lastKey = getGroupingKey(item);
      remaining--;

      buckets.sort((a, b) => b.length - a.length);
    }

    // 4. Strict Adjacent Check:
    // If product i and product i+1 have the same key, swap product i+1 with a random product with a different key
    for (let i = 0; i < reordered.length - 1; i++) {
      const curKey = getGroupingKey(reordered[i]);
      const nextKey = getGroupingKey(reordered[i + 1]);

      if (curKey === nextKey) {
        const candidateIndices = [];
        for (let j = i + 2; j < reordered.length; j++) {
          const candKey = getGroupingKey(reordered[j]);
          if (candKey !== curKey) {
            const nextOfCand = j + 1 < reordered.length ? getGroupingKey(reordered[j + 1]) : null;
            if (nextOfCand !== curKey) {
              candidateIndices.push(j);
            }
          }
        }

        if (candidateIndices.length > 0) {
          const swapIdx = candidateIndices[Math.floor(Math.random() * candidateIndices.length)];
          const temp = reordered[i + 1];
          reordered[i + 1] = reordered[swapIdx];
          reordered[swapIdx] = temp;
        }
      }
    }

    // 5. Append reordered items back to the grid
    const fragment = document.createDocumentFragment();
    reordered.forEach(function(item) {
      fragment.appendChild(item);
    });
    grid.appendChild(fragment);

    console.log('%c[Shopify Title Randomizer] SUCCESS!', 'color: #00ff88; font-weight: bold; font-size: 14px;');
    console.log('[Shopify Title Randomizer] Distinct types found on this page: ' + (hasMultipleBaseTitles ? baseTitles.size + ' different product types' : 'All items share base title "' + Array.from(baseTitles)[0] + '" (Dispersed by Part Number / SKU)'));
    console.log('[Shopify Title Randomizer] Dispersed ' + reordered.length + ' products on page without adjacent duplicates.');
    console.log('[Shopify Title Randomizer] Resulting Titles:', reordered.map(item => {
      const t = getItemFullTitle(item);
      const s = getItemSku(item);
      return s ? t + ' (SKU: ' + s + ')' : t;
    }));
  }

  // Alias functions for backward compatibility
  window.sortGridByBestSellingAndSku = disperseGridProductsByTitle;
  window.sortGridRandomByProductId = disperseGridProductsByTitle;
  window.disperseGridProductsByTitle = disperseGridProductsByTitle;

  /* ==========================================================
     BRAND COLLECTION MULTI-PAGE AGGREGATION & INSTANT FILTERING
     ========================================================== */
  const brandState = {
    sectionId: '',
    totalPages: 1,
    currentPage: 1,
    isAggregating: false,
    hasAggregated: false,
    allProductsMap: new Map(),   // prodId -> DOMElement clone
    brandProductMap: new Map(),  // brandKey (UPPERCASE) -> Set of prodIds
    brandTitles: new Map(),      // brandKey (UPPERCASE) -> display title
    initialGridItems: [],        // initial DOM elements of current page
    selectedBrands: new Set(),
    isApplyingFilter: false
  };

  let originalProductCountHtml = null;

  function ingestProductItem(item) {
    if (!item) return false;
    const rawSku = item.getAttribute('data-product-sku');
    const hasCard = item.querySelector('.product-card') !== null;
    if (!hasCard || (rawSku !== null && !rawSku.includes('/'))) {
      return false;
    }
    const prodId = item.getAttribute('data-product-id');
    if (!prodId) return false;

    if (!brandState.allProductsMap.has(prodId)) {
      brandState.allProductsMap.set(prodId, item.cloneNode(true));
    }

    const namesStr = item.getAttribute('data-brand-names') || '';
    if (namesStr) {
      namesStr.split(',').forEach(function(rawName) {
        const title = rawName.trim();
        if (!title) return;
        const key = title.toUpperCase();
        if (!brandState.brandTitles.has(key)) {
          brandState.brandTitles.set(key, title);
        }
        if (!brandState.brandProductMap.has(key)) {
          brandState.brandProductMap.set(key, new Set());
        }
        brandState.brandProductMap.get(key).add(prodId);
      });
    }
    return true;
  }

  async function aggregateAllPages() {
    if (brandState.totalPages <= 1 || brandState.isAggregating || brandState.hasAggregated) {
      return;
    }
    brandState.isAggregating = true;

    const pagesToFetch = [];
    for (let p = 1; p <= brandState.totalPages; p++) {
      if (p !== brandState.currentPage) {
        pagesToFetch.push(p);
      }
    }

    async function fetchPage(p) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', brandState.sectionId);
        url.searchParams.set('page', p);

        const res = await fetch(url.toString());
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('#product-grid .js-product-item');
        items.forEach(function(item) {
          ingestProductItem(item);
        });
        updateBrandSidebarUI();
        if (brandState.selectedBrands.size > 0) {
          renderFilteredGrid();
        }
      } catch (err) {
        console.warn('[Brand Aggregator] Failed to fetch page ' + p, err);
      }
    }

    const concurrency = 4;
    for (let i = 0; i < pagesToFetch.length; i += concurrency) {
      const batch = pagesToFetch.slice(i, i + concurrency);
      await Promise.all(batch.map(fetchPage));
    }

    brandState.isAggregating = false;
    brandState.hasAggregated = true;
    updateBrandSidebarUI();
    if (brandState.selectedBrands.size > 0) {
      renderFilteredGrid();
    }
  }

  function updateBrandSidebarUI() {
    const desktopLists = document.querySelectorAll('.facets__wrapper .js-brand-filter-list');
    const mobileLists = document.querySelectorAll('.mobile-facets__main .js-brand-filter-list');
    const totalBrandsWithProducts = Array.from(brandState.brandProductMap.values()).filter(s => s.size > 0).length;

    document.querySelectorAll('.js-brand-filter-details').forEach(function(detailsEl) {
      detailsEl.style.display = totalBrandsWithProducts > 0 ? '' : 'none';
    });

    if (totalBrandsWithProducts === 0) return;

    const sortedKeys = Array.from(brandState.brandProductMap.keys()).sort();

    // 1. Update Desktop List
    desktopLists.forEach(function(listEl) {
      sortedKeys.forEach(function(bKey, idx) {
        const count = brandState.brandProductMap.get(bKey).size;
        const bTitle = brandState.brandTitles.get(bKey) || bKey;
        let itemEl = listEl.querySelector('.js-brand-item[data-brand="' + CSS.escape(bKey) + '"]');

        if (!itemEl && count > 0) {
          const inputId = 'Filter-Brand-dyn-' + idx + '-' + brandState.sectionId;
          const li = document.createElement('li');
          li.className = 'list-menu__item facets__item js-brand-item';
          li.setAttribute('data-brand', bKey);
          li.innerHTML =
            '<label for="' + inputId + '" class="facet-checkbox">' +
              '<input type="checkbox" class="js-brand-filter-checkbox" value="' + bKey.replace(/"/g, '&quot;') + '" id="' + inputId + '">' +
              '<svg class="svg-box" width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
                '<rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>' +
              '</svg>' +
              '<svg class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />' +
              '</svg>' +
              '<span class="facet-checkbox__label">' + bTitle + '</span>' +
              '<span class="facet-checkbox__count">(' + count + ')</span>' +
              '<span class="visually-hidden">' + bTitle + ' (' + count + ')</span>' +
            '</label>';
          listEl.appendChild(li);
        } else if (itemEl) {
          const countEl = itemEl.querySelector('.facet-checkbox__count');
          if (countEl) countEl.textContent = '(' + count + ')';
          itemEl.style.display = count > 0 ? '' : 'none';
        }
      });
    });

    // 2. Update Mobile List
    mobileLists.forEach(function(listEl) {
      sortedKeys.forEach(function(bKey, idx) {
        const count = brandState.brandProductMap.get(bKey).size;
        const bTitle = brandState.brandTitles.get(bKey) || bKey;
        let itemEl = listEl.querySelector('.js-brand-item[data-brand="' + CSS.escape(bKey) + '"]');

        if (!itemEl && count > 0) {
          const inputId = 'Filter-Brand-mob-dyn-' + idx + '-' + brandState.sectionId;
          const li = document.createElement('li');
          li.className = 'mobile-facets__item list-menu__item js-brand-item';
          li.setAttribute('data-brand', bKey);
          li.innerHTML =
            '<label for="' + inputId + '" class="mobile-facets__label">' +
              '<input class="mobile-facets__checkbox js-brand-filter-checkbox" type="checkbox" value="' + bKey.replace(/"/g, '&quot;') + '" id="' + inputId + '">' +
              '<span class="mobile-facets__highlight"></span>' +
              '<svg class="svg-box" width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
                '<rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>' +
              '</svg>' +
              '<svg class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />' +
              '</svg>' +
              '<span aria-hidden="true">' + bTitle + ' (' + count + ')</span>' +
              '<span class="visually-hidden">' + bTitle + ' (' + count + ')</span>' +
            '</label>';
          listEl.appendChild(li);
        } else if (itemEl) {
          const mobileSpan = itemEl.querySelector('.mobile-facets__label span[aria-hidden="true"]');
          if (mobileSpan) {
            mobileSpan.textContent = bTitle + ' (' + count + ')';
          }
          itemEl.style.display = count > 0 ? '' : 'none';
        }
      });
    });

    // 3. Keep all checkboxes in sync with brandState.selectedBrands
    document.querySelectorAll('.js-brand-filter-checkbox').forEach(function(cb) {
      cb.checked = brandState.selectedBrands.has((cb.value || '').trim().toUpperCase());
    });
  }

  function renderFilteredGrid() {
    if (brandState.isApplyingFilter) return;
    brandState.isApplyingFilter = true;

    try {
      const grid = document.getElementById('product-grid');
      if (!grid) return;

      const isFiltered = brandState.selectedBrands.size > 0;

      if (!isFiltered) {
        // Restore initial page elements
        grid.innerHTML = '';
        brandState.initialGridItems.forEach(function(el) {
          grid.appendChild(el.cloneNode(true));
        });
        updatePaginationVisibility(false);
        updateProductCounts(0, 0, false);
        updateBrandActivePills([]);
        updateBrandHeaders(0);
        disperseGridProductsByTitle();
        return;
      }

      // Hide pagination when filtering
      updatePaginationVisibility(true);

      // Collect union of product IDs matching any selected brand
      const matchingIds = new Set();
      brandState.selectedBrands.forEach(function(bKey) {
        const prodSet = brandState.brandProductMap.get(bKey);
        if (prodSet) {
          prodSet.forEach(id => matchingIds.add(id));
        }
      });

      // Clear grid and populate with matching product cards
      grid.innerHTML = '';
      matchingIds.forEach(function(prodId) {
        const itemEl = brandState.allProductsMap.get(prodId);
        if (itemEl) {
          const clone = itemEl.cloneNode(true);
          clone.style.display = '';
          grid.appendChild(clone);
        }
      });

      // Update counters, pills, headers
      updateProductCounts(matchingIds.size, matchingIds.size, true);
      updateBrandActivePills(Array.from(brandState.selectedBrands));
      updateBrandHeaders(brandState.selectedBrands.size);
      disperseGridProductsByTitle();
    } finally {
      brandState.isApplyingFilter = false;
    }
  }

  function updatePaginationVisibility(isFiltered) {
    const paginationContainers = document.querySelectorAll(
      '.pagination-wrapper, .pagination, .AjaxinatePagination, nav[role="navigation"].pagination'
    );
    paginationContainers.forEach(function(el) {
      if (isFiltered) {
        el.style.setProperty('display', 'none', 'important');
      } else {
        el.style.removeProperty('display');
      }
    });
  }

  function updateProductCounts(visibleCount, totalValidCount, isFiltered) {
    const desktopCount = document.getElementById('ProductCountDesktop');
    const mobileCount = document.getElementById('ProductCount');

    if (!originalProductCountHtml && desktopCount) {
      originalProductCountHtml = desktopCount.innerHTML;
    }

    if (isFiltered) {
      const text = '<span>' + visibleCount + ' ' + (visibleCount === 1 ? 'product' : 'products') + '</span>';
      if (desktopCount) desktopCount.innerHTML = text;
      if (mobileCount) mobileCount.innerHTML = text;
    } else {
      if (originalProductCountHtml && desktopCount) {
        desktopCount.innerHTML = originalProductCountHtml;
      }
      if (originalProductCountHtml && mobileCount) {
        mobileCount.innerHTML = originalProductCountHtml;
      }
    }
  }

  function updateBrandHeaders(selectedCount) {
    document.querySelectorAll('.js-brand-selected-count').forEach(function(el) {
      if (selectedCount > 0) {
        el.textContent = ' ' + selectedCount;
        el.classList.remove('hidden');
      } else {
        el.textContent = ' 0';
        el.classList.add('hidden');
      }
    });

    document.querySelectorAll('.js-brand-reset-btn').forEach(function(btn) {
      btn.style.display = selectedCount > 0 ? '' : 'none';
    });
  }

  function updateBrandActivePills(selectedBrandKeys) {
    document.querySelectorAll('.js-brand-active-facet-pill').forEach(function(pill) {
      pill.remove();
    });

    if (selectedBrandKeys.length === 0) return;

    const desktopContainer = document.querySelector('.active-facets-desktop');
    const mobileContainer = document.querySelector('.active-facets-mobile');

    selectedBrandKeys.forEach(function(bKey) {
      const bTitle = brandState.brandTitles.get(bKey) || bKey;
      const pillHtml = '<facet-remove class="js-brand-active-facet-pill" data-brand="' + bKey + '">' +
        '<a href="javascript:void(0);" class="active-facets__button active-facets__button--light js-brand-pill-remove">' +
          '<span class="active-facets__button-inner button button--tertiary">' +
            'Brand: ' + bTitle +
            ' <svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 12 12" style="margin-left: 6px;"><path fill="currentColor" d="M9.53 2.47a.75.75 0 0 0-1.06 0L6 4.94 3.53 2.47a.75.75 0 0 0-1.06 1.06L4.94 6 2.47 8.47a.75.75 0 1 0 1.06 1.06L6 7.06l2.47 2.47a.75.75 0 0 0 1.06-1.06L7.06 6l2.47-2.47a.75.75 0 0 0 0-1.06Z"/></svg>' +
          '</span>' +
        '</a>' +
      '</facet-remove>';

      if (desktopContainer) desktopContainer.insertAdjacentHTML('beforeend', pillHtml);
      if (mobileContainer) mobileContainer.insertAdjacentHTML('beforeend', pillHtml);
    });

    document.querySelectorAll('.js-brand-pill-remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const pill = btn.closest('.js-brand-active-facet-pill');
        const bKey = pill ? pill.getAttribute('data-brand') : null;
        if (bKey) {
          brandState.selectedBrands.delete(bKey.toUpperCase());
          document.querySelectorAll('.js-brand-filter-checkbox[value="' + CSS.escape(bKey) + '"]').forEach(function(cb) {
            cb.checked = false;
          });
          renderFilteredGrid();
        }
      });
    });
  }

  let brandListenersInitialized = false;
  function initBrandFilterListeners() {
    if (brandListenersInitialized) return;
    brandListenersInitialized = true;

    document.addEventListener('change', function(e) {
      if (e.target && e.target.classList.contains('js-brand-filter-checkbox')) {
        e.stopPropagation();
        const bKey = (e.target.value || '').trim().toUpperCase();
        if (e.target.checked) {
          brandState.selectedBrands.add(bKey);
        } else {
          brandState.selectedBrands.delete(bKey);
        }
        document.querySelectorAll('.js-brand-filter-checkbox[value="' + CSS.escape(e.target.value) + '"]').forEach(function(cb) {
          cb.checked = e.target.checked;
        });
        renderFilteredGrid();
      }
    }, true);

    document.addEventListener('input', function(e) {
      if (e.target && e.target.classList.contains('js-brand-filter-checkbox')) {
        e.stopPropagation();
      }
    }, true);

    document.addEventListener('click', function(e) {
      if (e.target && (e.target.classList.contains('js-brand-reset-btn') || e.target.closest('.js-brand-reset-btn'))) {
        e.preventDefault();
        e.stopPropagation();
        brandState.selectedBrands.clear();
        document.querySelectorAll('.js-brand-filter-checkbox').forEach(function(cb) {
          cb.checked = false;
        });
        renderFilteredGrid();
      }
    });
  }

  function initBrandAggregationSystem() {
    const brandDetails = document.querySelector('.js-brand-filter-details');
    if (!brandDetails) {
      removeSlashlessItems();
      return;
    }

    initBrandFilterListeners();
    removeSlashlessItems();

    const grid = document.getElementById('product-grid');
    if (!grid) return;

    brandState.sectionId = grid.getAttribute('data-id') || '';
    brandState.totalPages = parseInt(grid.getAttribute('data-total-pages') || '1', 10);
    brandState.currentPage = parseInt(grid.getAttribute('data-current-page') || '1', 10);

    // Save initial page elements
    brandState.initialGridItems = Array.from(grid.querySelectorAll('.js-product-item')).map(el => el.cloneNode(true));

    // Ingest initial DOM items
    grid.querySelectorAll('.js-product-item').forEach(function(item) {
      ingestProductItem(item);
    });

    updateBrandSidebarUI();

    // Start background multi-page fetching
    aggregateAllPages();
  }

  window.applyBrandFilter = renderFilteredGrid;
  window.syncBrandFiltersFromGrid = updateBrandSidebarUI;

  // Run on DOM ready
  document.addEventListener("DOMContentLoaded", function() {
    initBrandAggregationSystem();
    fillGridToTarget();

    // Support Ajaxinate (Click and Scroll pagination)
    const getpagi = document.querySelector('.AjaxinatePagination');
    if (typeof(getpagi) !== "undefined" && getpagi !== null) {
      const elem = getpagi.getAttribute('data-pagination');
      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem == 'scroll' ? 'scroll' : 'click',
        callback: function() {
          removeSlashlessItems();
          fillGridToTarget();
          updateBrandSidebarUI();
          if (brandState.selectedBrands.size > 0) {
            renderFilteredGrid();
          }
        }
      });
    }

    // MutationObserver to safely catch dynamic DOM modifications
    const productGrid = document.getElementById('product-grid');
    if (productGrid) {
      let isSorting = false;
      const observer = new MutationObserver(function(mutations) {
        if (isSorting || isBackfilling || brandState.isApplyingFilter) return;
        removeSlashlessItems();
        if (brandState.selectedBrands.size === 0 && shouldDisperseGrid()) {
          isSorting = true;
          disperseGridProductsByTitle();
          setTimeout(function() { isSorting = false; }, 120);
        }
      });
      observer.observe(productGrid, { childList: true });
    }
  });

  // Also run on window load to ensure all dynamic elements are ready
  window.addEventListener('load', function() {
    initBrandAggregationSystem();
    fillGridToTarget();
  });

  document.addEventListener('shopify:section:load', function() {
    initBrandAggregationSystem();
    fillGridToTarget();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
  var initPhotoSwipeFromDOM = function (gallerySelector) {
    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    var parseThumbnailElements = function (el) {
      var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
        numNodes = thumbElements.length,
        items = [],
        figureEl,
        linkEl,
        size,
        item;

      for (var i = 0; i < numNodes; i++) {
        figureEl = thumbElements[i]; // <figure> element
        // include only element nodes
        if (figureEl.nodeType !== 1) {
          continue;
        }

        linkEl = figureEl.children[0]; // <a> element
        if (linkEl.getAttribute('data-size')) {
          size = linkEl.getAttribute('data-size').split('x');
        } else {
          size = [];
        }

        // create slide object
        item = {
          src: linkEl.getAttribute('href'),
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10),
        };

        if (figureEl.children.length > 1) {
          // <figcaption> content
          item.title = figureEl.children[1].innerHTML;
        }

        if (linkEl.children.length > 0) {
          // thumbnail element, retrieving thumbnail url
          item.msrc = linkEl.children[0].getAttribute('src');
        }

        item.el = figureEl; // save link to element for getThumbBoundsFn
        items.push(item);
      }

      return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
      return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function (e) {
      e = e || window.event;
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);

      var eTarget = e.target || e.srcElement;

      // find root element of slide
      var clickedListItem = closest(eTarget, function (el) {
        return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
      });

      if (!clickedListItem) {
        return;
      }

      // find index of clicked item by looping through all child nodes
      // alternatively, you may define index via data- attribute
      var clickedGallery = clickedListItem.parentNode,
        childNodes = clickedListItem.parentNode.childNodes,
        numChildNodes = childNodes.length,
        nodeIndex = 0,
        index;

      for (var i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) {
          continue;
        }

        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }

      if (index >= 0) {
        // open PhotoSwipe if valid index found
        openPhotoSwipe(index, clickedGallery);
      }
      return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function () {
      var hash = window.location.hash.substring(1),
        params = {};

      if (hash.length < 5) {
        return params;
      }

      var vars = hash.split('&');
      for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) {
          continue;
        }
        var pair = vars[i].split('=');
        if (pair.length < 2) {
          continue;
        }
        params[pair[0]] = pair[1];
      }

      if (params.gid) {
        params.gid = parseInt(params.gid, 10);
      }

      return params;
    };

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
      var pswpElement = document.querySelectorAll('.pswp')[0],
        gallery,
        options,
        items;

      items = parseThumbnailElements(galleryElement);

      // define options (if needed)
      options = {
        maxSpreadZoom: 1,
        bgOpacity: 0.7,
        zoomEl: true,
        history: false,
        pinchToClose: false,
        closeOnScroll: false,

        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      };

      // PhotoSwipe opened from URL
      if (fromURL) {
        if (options.galleryPIDs) {
          // parse real index when custom PIDs are used
          // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
          for (var j = 0; j < items.length; j++) {
            if (items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          // in URL indexes start from 1
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }

      // exit if index not found
      if (isNaN(options.index)) {
        return;
      }

      if (disableAnimation) {
        options.showAnimationDuration = 0;
      }

      // Pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector);

    for (var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute('data-pswp-uid', i + 1);
      galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
      openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
  };

  // execute above function
  initPhotoSwipeFromDOM('.my-gallery');

  } catch(e) { console.error(e); }
})();
})();
